import template from './modal-close.template.html';
import './modal-close.scss';

export default {
  template,
};



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-close/modal-close.component.js